module.exports = __webpack_public_path__ + "media/flags/gw-5d7e5d20.svg";